import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';

import rootReducer from './reducers/index';

export default function createStore(preloadedState, history) {
  const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({ history });

  const store = configureStore({
    reducer: rootReducer(routerReducer),
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      // eslint-disable-next-line no-undef
      __BROWSER__ ? getDefaultMiddleware().concat(routerMiddleware) : getDefaultMiddleware(),
  });

  return { store, history: createReduxHistory(store) };
}
